var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.borders),function(border){return _c('div',{staticClass:"grid__row-border",style:(border.style)})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }